import dayjs from 'dayjs';

import { ExportReportsAchievementParams, ExportReportsScheduleParams } from '../types/report.types';
import { normalizeOutputReportAxiosError } from '../utils/output-report-axios-error';

import { apiClient } from '@/axios';
import { downloadBlob } from '@/utils/helpers';

const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const REPORT_EXPORT_TIMEOUT_MS = 30_000;

export const exportReportsSchedule = async (params: ExportReportsScheduleParams) => {
  try {
    const response = await apiClient.post('/v1/output-reports/schedule', params, {
      responseType: 'blob',
      timeout: REPORT_EXPORT_TIMEOUT_MS,
      skipGlobalErrorNormalization: true,
    });
    const fileName = `予定表_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`;
    downloadBlob(response.data, fileName, EXCEL_MIME_TYPE);
  } catch (error) {
    throw await normalizeOutputReportAxiosError(error);
  }
};

export const exportReportsAchievement = async (params: ExportReportsAchievementParams) => {
  try {
    const response = await apiClient.post('/v1/output-reports/achievement', params, {
      responseType: 'blob',
      timeout: REPORT_EXPORT_TIMEOUT_MS,
      skipGlobalErrorNormalization: true,
    });
    const fileName = `実績確認チェックリスト_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`;
    downloadBlob(response.data, fileName, EXCEL_MIME_TYPE);
  } catch (error) {
    throw await normalizeOutputReportAxiosError(error);
  }
};
